<template>
  <LsModal title="Cancel Order?" track-id="cancel_order_modal">
    <template #body>
      <p class="cancel-order-modal--p">
        By not agreeing to these policies, your order will be cancelled.
      </p>
    </template>
    <template #footer
      ><LsButton
        text="cancel order"
        track-id="cancel_order_modal-cancel_order"
        :loading="onboarding.loadingStatus.isRemoving || reactivation.loadingStatus.isUpdating"
        test-id="cancel_order"
        @click="cancelOrder"
    /></template>
  </LsModal>
</template>

<script>
import { LsModal, LsButton } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { ONBOARDING__CANCEL_ORDER, REACTIVATION__DISAGREE_WITH_POLICIES } from '@/store/types';
import VueTypes from 'vue-types';

export default {
  name: 'CancelOrderModal',
  components: {
    LsModal,
    LsButton,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.string,
  },
  computed: {
    ...mapState(['onboarding', 'reactivation']),
  },
  methods: {
    ...mapActions([ONBOARDING__CANCEL_ORDER, REACTIVATION__DISAGREE_WITH_POLICIES]),
    cancelOrder() {
      if (this.property_id) {
        this[REACTIVATION__DISAGREE_WITH_POLICIES]({
          property_id: this.property_id,
          onSuccess: () => {
            this.$parent.close();
            this.$router.replace({
              name: 'services',
            });
          },
        });
      } else {
        this[ONBOARDING__CANCEL_ORDER]({ onSuccess: this.$parent.close });
      }
    },
  },
};
</script>

<style lang="scss">
.cancel-order-modal--p {
  color: $primary;
}
.themed-app {
  .cancel-order-modal--p {
    color: $theme-color-primary;
  }
}
</style>
